import * as THREE from 'three';

/**
 * 静的オクルーダーメッシュ(計画書§8.2)。
 * 「見えないが深度だけ書く」マテリアルに差し替え、背後の3Dコンテンツを遮蔽する。
 * 深度センシング非対応のiOS(パスB)でも地形・建物による遮蔽演出を可能にする。
 */
export function makeOccluder(root: THREE.Object3D): THREE.Object3D {
  root.traverse((obj) => {
    if (obj instanceof THREE.Mesh) {
      const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
      for (const m of mats) m.dispose();
      obj.material = new THREE.MeshBasicMaterial({
        colorWrite: false, // 色は描かない
        depthWrite: true, // 深度だけ書く
      });
      // 通常コンテンツより先に描画して深度バッファを作る
      obj.renderOrder = -100;
    }
  });
  root.name = 'occluder';
  return root;
}
